module.exports = __webpack_public_path__ + "img/error500.04ad0401.png";